(function ($) {
  const storeId = window.partner.storeId.toString();
  const customerInfoElm = $('#customer-infor');

  const customerInfo = {
    customerId: customerInfoElm.data('customer-id'),
    partnerCode: customerInfoElm.data('partner-code'),
    partnerType: customerInfoElm.data('partner-type'),
    customerEmail: customerInfoElm.data('customer-email'),
  }
  
  const currentPage = window.location.href;
  const loginPage = `https://login.sony-asia.com/10a6c4a3-6d70-4565-9c95-e3b2581b4018/oauth2/v2.0/authorize?p=B2C_1_PartnerMY_PRD_si_su&client_id=d79ed5f0-cadc-4029-bb82-945b9286e31e&nonce=defaultNonce&redirect_uri=https://www.sony.com.my/storeapi/partners/26901250127/auth&scope=openid&response_type=id_token&prompt=login&response_mode=form_post&ui_locales=en`;
  const staffLoginPage = 'pages/staff';
  const partnerCodePage = 'pages/partner-code';
  const forgotPswPage = 'account/login';
  const resetPswPage = 'account/reset';
  const resetPswPageTpl = 'pages/reset-password';
  const recoverPswPage = 'account/recover';
  const activateAccPage = 'account/activate';
  const registerPage = 'account/register';
  const challengePage = '/challenge';
  const privacyPages = 'pages/privacy-policy';
  const privacyPagesEN = 'pages/en-privacy-policy';
  const termCoditionPages = 'pages/term-of-use';
  const termCoditionPagesEN = 'pages/en-term-of-use';

  
  function checkCustomerAndPages() {
    if(customerInfo.customerId &&
      currentPage.indexOf(forgotPswPage) === -1 &&
      currentPage.indexOf(resetPswPage) === -1 &&
      currentPage.indexOf(resetPswPageTpl) === -1 &&
      currentPage.indexOf(recoverPswPage) === -1 &&
      currentPage.indexOf(activateAccPage) === -1) {
        return true;
    };

    return false;
  };

  function handleOtherPages() {
    if(currentPage.indexOf(storeId + "/checkouts") === -1) {
      sessionStorage.setItem("idleTime", 0);
  
      if(currentPage.indexOf(loginPage) == -1 &&
        currentPage.indexOf(staffLoginPage) == -1 &&
        currentPage.indexOf(partnerCodePage) == -1 &&
        currentPage.indexOf(registerPage) === -1 &&
        currentPage.indexOf(activateAccPage) === -1 &&
        currentPage.indexOf(recoverPswPage) === -1 &&
        currentPage.indexOf(resetPswPage) === -1 &&
        currentPage.indexOf(resetPswPageTpl) === -1 &&
        currentPage.indexOf(forgotPswPage) === -1 &&
        currentPage.indexOf(challengePage) === -1 &&
        currentPage.indexOf(privacyPages) === -1 &&
        currentPage.indexOf(privacyPagesEN) === -1 &&
        currentPage.indexOf(termCoditionPages) === -1 &&
        currentPage.indexOf(termCoditionPagesEN) === -1
      ){
        window.top.location.href = loginPage;
      };
    };
  }

  function initEvt() {
    //Zero the idle timer on mouse movement.
    $(document).mousemove(function (e) {
      sessionStorage.setItem("idleTime", 0);
    }); 

    $(document).click(function (e) {
      sessionStorage.setItem("idleTime", 0);
    });

    $(document).keypress(function (e) {
      sessionStorage.setItem("idleTime", 0);
    });
  };

  function initTimer() {
    const idleTime = parseInt(sessionStorage.getItem("idleTime")) + 1;

    sessionStorage.setItem("idleTime", idleTime);

    if (idleTime > 19) { // 20 minutes
      sessionStorage.removeItem("idleTime");
      logoutPartner();
    };

    // binding event
    initEvt();
  };

  function logoutPartner() {
    if(
      customerInfo.customerId &&
      currentPage.indexOf(loginPage) == -1 &&
      currentPage.indexOf(staffLoginPage) == -1 &&
      currentPage.indexOf(forgotPswPage) == -1 &&
      currentPage.indexOf(resetPswPage) == -1 &&
      currentPage.indexOf(resetPswPageTpl) == -1
    ){
      $.ajax('/account/logout').done(() => {
        if(customerInfo.partnerType.toLowerCase() === 'staff') {
          // Login Staff Partner
          window.top.location.href = staffLoginPage;
        }
        else {
          // Login Customer Partner
          window.top.location.href = loginPage;
        };
      })
    };
  };

  function addNewPriceAttribute(selectElm, inputElm, price) {
    if (selectElm.length) {
      selectElm.data('new-price', price);
      return;
    }

    inputElm.data('new-price', price);
  }
  
  function updateProductDetailPrice(partnerPrice, selectElm, inputElm, productElm) {
    const price = selectElm?.find('option:selected').data('price') || inputElm?.data('price');
    const comparePrice = selectElm?.find('option:selected').data('compare-price') || inputElm?.data('compare-price');
    
    const newPrice = comparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
    const oldPrice = comparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
    const discountPercent = (oldPrice - newPrice) / oldPrice * 100;
    
    if(partnerPrice) {
      addNewPriceAttribute(selectElm, inputElm, newPrice);
    }
    
    if((comparePrice && (price === newPrice) && (comparePrice === oldPrice)) || !comparePrice && (price === newPrice)) return;
    
    // update price ==> format money
    const productPrices = productElm.find('.product__prices');

    productPrices.hide().empty();

    if (comparePrice && oldPrice > newPrice) {
      productElm.find(".product__slideshow .discount").show();
      productElm.find(".product__slideshow .discount .price-save").html(discountPercent.toFixed(0)+"%");

      productPrices.append(`
        <span class="product__price product__price--new h4" data-money-convertible>
          ${Shopify.formatMoney(newPrice, window.theme.moneyFormat)}
        </span>
      `);

      productPrices.append(`
        <span class="product__price product__price--old h4" data-money-convertible>
          ${Shopify.formatMoney(oldPrice, window.theme.moneyFormat)}
        </span>
      `);
    } 
    else {
      productElm.find(".product__slideshow .discount").hide();

      productPrices.append(`
        <span class="product__price h4" data-money-convertible>
          ${Shopify.formatMoney(newPrice, window.theme.moneyFormat)}
        </span>
      `);
    };

    productPrices.show();

  };

  function getPriceByProductId(token) {
    const elms = $('[data-actions="getPriceByProductId"]');

    elms.each((_, elm) => {
      const self = $(elm);
      const productId = self.data('product-id').toString();
      const productPriceWrapper = self.find('.product__prices_wrapper');

      if(!productId) return;
  
      productPriceWrapper.addClass('spinner-loading');
      self.find('.product__add-to-cart:not(.sold-out)').attr('disabled', 'disabled').addClass('button--loading');

      $.ajax({
        method: 'POST',
        url: `${window.partner.omsGetPriceByProductId}`,
        headers: {
          'Authorization': `Bearer ${token}`,
          'issuer': storeId,
          'Accept-Language': 'en-US'
        },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
          'storeid': storeId,
          'customeremail': customerInfo.customerEmail.toLowerCase(),
          'partnercode': customerInfo.partnerCode,
          'productid': productId
        })
      }).done(result => {
        const resultValue = JSON.parse(result?.value)[0];
        if (!resultValue?.variant?.length || resultValue?.productid != productId) return;

        const selectElm = self.find('select[name="id"]');
        const inputElm = self.find('input[name="id"]');

        const variantId = selectElm.find('option:selected').val() || inputElm.val();
        const partnerOrginalPrice = resultValue.variant.find(v => v.id === variantId)?.price;
        if (!partnerOrginalPrice) return;
        
        updateProductDetailPrice(partnerOrginalPrice * 100, selectElm, inputElm, self);

        $(document).on('variant_changed.product', function(evt, variant) {
          const variantId = selectElm.find('option:selected').val();
          // const variantId = variant.id;
          const partnerOrginalPrice = resultValue.variant.find(v => v.id === variantId)?.price;
  
          if (!partnerOrginalPrice) return;
  
          updateProductDetailPrice(partnerOrginalPrice * 100, selectElm, inputElm, self);
        });
  
      }).fail(err => {
        console.log('err: ', err);
  
      }).always(() => {
        productPriceWrapper.removeClass('spinner-loading');
        self.find('.product__add-to-cart:not(.sold-out)').removeAttr('disabled').removeClass('button--loading');
      })
    });
  }

  function updateProductItemPrice(price, comparePrice, partnerPrice, productItemElm) {
    const newPrice = comparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
    const oldPrice = comparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
    const discountPercent = (oldPrice - newPrice) / oldPrice * 100;
    const newPriceFormatted = Shopify.formatMoney(newPrice, window.theme.moneyFormat);
    const oldPriceFormatted = Shopify.formatMoney(oldPrice, window.theme.moneyFormat);

    if(partnerPrice) {
      addNewPriceAttribute(productItemElm.find('.product-content-bottom'), undefined , newPrice);
    }

    if((comparePrice && (price === newPrice) && (comparePrice === oldPrice)) || !comparePrice && (price === newPrice)) return;

    // update price ==> format money
    if (comparePrice && oldPrice > newPrice) {
      productItemElm.find(".product-item__image-container .discount").show();
      productItemElm.find(".product-item__image-container .discount .price-save").html(discountPercent.toFixed(0)+"%");

      productItemElm.find('.product-item__price').remove();
      
      if (!productItemElm.find('.product-item__price--old').length) {
        productItemElm.find('.product-content-bottom').prepend(`
          <span class="product-item__price product-item__price--old" data-money-convertible>
          ${oldPriceFormatted}
          </span>
        `)
      } else {
        productItemElm.find('.product-item__price--old').html(oldPriceFormatted);
      }

      if (!productItemElm.find('.product-item__price--new').length) {
        productItemElm.find('.product-content-bottom').prepend(`
          <span class="product-item__price product-item__price--new" data-money-convertible>
          ${newPriceFormatted}
          </span>
        `)
      } else {
        productItemElm.find('.product-item__price--new').html(newPriceFormatted);
      }
    } 
    else {
      productItemElm.find(".product-item__image-container .discount").hide();
      productItemElm.find('.product-item__price').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat));
    };
  }

  function getPriceForProductListing(token) {
    const elms = $('[data-actions="GetPriceByListProductIds"]');

    elms.each((_, e) => {
      const elm = $(e);
      const listProductIds = elm.siblings('[data-list-product-ids]').val();

      if(!listProductIds) return;

      const productIdsArr = listProductIds.split(',').map((item) => {
        return parseInt(item);
      });

      elm.find('.product-item .product__add-to-cart:not(".sold-out")').attr('disabled', 'disabled').addClass('button--loading');

      $('#shopify-section-collection-template .loading-page-product').addClass('show');

      $.ajax({
        method: 'POST',
        url: `${window.partner.omsGetPriceByListProductIds}`,
        headers: {
          'Authorization': `Bearer ${token}`,
          'issuer': storeId,
          'Accept-Language': 'en-US'
        },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
          'storeid': storeId,
          'listproductid': JSON.stringify(productIdsArr),
          'partnercode': customerInfo.partnerCode,
          'customeremail': customerInfo.customerEmail.toLowerCase()
        })
      }).done(result => {
        const listProductItems = elm.find('.product-item');
        const resultValue = JSON.parse(result?.value);

        listProductItems.each(function(_, item) {
          const productItemElm =$(item);
          const productItemId = productItemElm.data('product-id').toString();
          const productItemData = resultValue.find(item => item.productid === productItemId);
          
          if (!productItemData) return;

          const variantId = productItemElm.find('.product-content-bottom').data('variant-id').toString();
          const variantData = productItemData.variant.find(v => v.id === variantId);

          if (!variantData) return;

          const partnerOrginalPrice = variantData.price;

          if(!partnerOrginalPrice) return;

          const price = productItemElm.find('.product-content-bottom').data('price');
          const comparePrice = productItemElm.find('.product-content-bottom').data('compare-price');

          // update price
          updateProductItemPrice(price, comparePrice, partnerOrginalPrice * 100, productItemElm);
        });

      }).fail(err => {
        console.log('err: ', err);
        $('.collection.page__content-wrapper .div-message').addClass('show');
  
      }).always(() => {
        $('#shopify-section-collection-template .loading-page-product').removeClass('show');
        elm.find('.product-item .product__add-to-cart:not(".sold-out")').removeAttr('disabled').removeClass('button--loading');
      })
    })
  }

  function handleLogout() {
    const logoutSlt = '[data-actions="logout"]';

    $(document).on('click', logoutSlt, function(e) {
      e.preventDefault();
      e.stopPropagation();

      logoutPartner();
    })
  }

  $(function() {
    if (checkCustomerAndPages()) {
      window.getOMSAccessToken().then((token) => {
        getPriceByProductId(token);
        getPriceForProductListing(token);
      }).catch(err => console.log('error when call get OMS access token', err));

      setInterval(initTimer, 60 * 1000);
      handleLogout();
    } 
    else {
      $('#shopify-section-collection-template .loading-page-product').removeClass('show');
      handleOtherPages();
    };
  });

}(jQuery));
